import MessagingApi from "@/api/messaging"

const state = {
  conversations: [],
  activeConversation: null,
  unreadCount: 0,
  pollingInterval: null,
}

const mutations = {
  SET_CONVERSATIONS: (state, conversations) => {
    state.conversations = conversations
  },
  SET_ACTIVE_CONVERSATION: (state, data) => {
    state.activeConversation = data
  },
  SET_UNREAD_COUNT: (state, count) => {
    state.unreadCount = count
  },
  SET_POLLING_INTERVAL: (state, interval) => {
    state.pollingInterval = interval
  },
}

const getters = {}

const actions = {
  async fetchConversations({ commit }, params) {
    try {
      const { data } = await MessagingApi.getConversations(params)
      commit("SET_CONVERSATIONS", data)
    } catch (error) {
      console.log(error)
    }
  },

  async fetchConversation({ commit }, id) {
    try {
      const { data } = await MessagingApi.getConversation(id)
      commit("SET_ACTIVE_CONVERSATION", data)
    } catch (error) {
      console.log(error)
    }
  },

  async sendMessage({ dispatch }, { conversationId, body }) {
    try {
      await MessagingApi.sendMessage(conversationId, body)
      await dispatch("fetchConversation", conversationId)
    } catch (error) {
      console.log(error)
      throw error
    }
  },

  async markConversationRead({ dispatch }, id) {
    try {
      await MessagingApi.markRead(id)
      await Promise.all([
        dispatch("fetchUnreadCount"),
        dispatch("fetchConversations"),
      ])
    } catch (error) {
      console.log(error)
    }
  },

  async fetchUnreadCount({ commit }) {
    try {
      const { data } = await MessagingApi.getUnreadCount()
      commit("SET_UNREAD_COUNT", data.count)
    } catch (error) {
      console.log(error)
    }
  },

  startPolling({ dispatch, commit, state }, conversationId) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval)
    }
    const interval = setInterval(() => {
      dispatch("fetchConversation", conversationId)
    }, 5000)
    commit("SET_POLLING_INTERVAL", interval)
  },

  stopPolling({ commit, state }) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval)
    }
    commit("SET_POLLING_INTERVAL", null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
